import React, { Component } from "react";
import { connect } from "react-redux";
import { subMonths, startOfMonth, endOfMonth, format } from "date-fns";
import Loader from "../../../components/loader";
import {
  turnoverRate,
  turnoverViews,
  saveTurnoverView,
  turnoverGroupings,
  deleteSavedView,
  confirmDeleteGrouping,
  deleteCustomGrouping,
} from "../../../store/actions";
import { groupBy, startCase, sortBy, reduce, map, uniq } from "lodash";
import {
  startAndEndOfMonthsInRange,
  enumerateDatesInRange,
  isSameOrBefore,
  isSameOrAfter,
} from "../../../utils/dateHelper";
import ReportDateRange from "../../../components/reportDateRange";
import Ranges from "../../../utils/date-ranges";
import TurnoverView from "./turnoverView";
import Switch from "../../../components/switch";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import SaveViewModal from "./saveViewModal";
import GroupingModal from "./groupingModal_copy";
import "./style.scss";
import ToastMessage from "../../../components/toast";
import { Tooltip } from "react-tooltip";
import informationTooltip from "../../../assets/images/information-tooltip.jpg";
import searchIcon from "../../../assets/images/searchIcon.png";
import pinnedFilterIcon from "../../../assets/images/pinned_icon.png";
import OutsideClickHandler from "react-outside-click-handler";
import Portal from "../../../components/portal";
import { ConfirmationPopUp } from "../../../components/confirmation";
import {
  DragDropContext,
  Draggable,
  Droppable,
} from "react-beautiful-dnd";
class TurnoverRateReport extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    advanceGroupingValues: {},
    availFilterColumns: [],
    availableColumns: [],
    breakDownDrop: false,
    breakdownColumns: [],
    btnDisable: false,
    company: "",
    deleteViewId: "",
    detailed: false,
    draggedIndex: null,
    draggedOver: 0,
    editViewData: {},
    endDate: endOfMonth(subMonths(new Date(), 0)),
    exportDataList: [],
    filterColValues: [],
    filterValues: {},
    filters: [],
    getFilter: {},
    groupedReport: {},
    isEdit: false,
    isOpenSettings: false,
    isRender: false,
    isShow: false,
    isShowGroupingModal: false,
    isShowHideView: false,
    items: {
      available: [],
      assigned: [],
    },
    loading: false,
    monthNames: [],
    monthly: false,
    preparedRecords: [],
    ranges: Ranges,
    records: [],
    savedAvailableColumns: [],
    savedBreakdowns: [],
    savedFilters: [],
    savedViews: [],
    searchAvailableColumn: "",
    searchAvailableFields: "",
    searchBreakdown: "",
    searchFilter: "",
    selectedLabel: "Last Month",
    selectedRange: {},
    showConfirmationBox: false,
    showHideAvail: false,
    showHideAvailFilter: false,
    showHideBreak: false,
    showHideFilterBy: false,
    sourceList: "",
    startDate: startOfMonth(subMonths(new Date(), 0)),
    viewId: "",
    viewLabel: "",
  };

  startUpRange = {};
  cloneGroup = [];
  cloneRecords = [];
  async componentDidMount() {
    this.setState({ loading: true });

    //firstly get saved views of the report - if any
    let { company, companyId } = this.props.UserReducer;
    let views = await this.getViews(companyId);

    this.setState({
      savedViews: views,
      company,
    });
    await this.getFilterValue();
    //get custom groups (advance grouping)
    await this.props.turnoverGroupings(companyId);
    //find default view if any
    let defaultView = views.find((view) => {
      return view.isDefault;
    });
    //if we have default view, set the state with default
    if (defaultView) {
      this.setState({
        breakdownColumns: this.mapBreakdownColumns(defaultView.breakdowns),
        detailed: defaultView.detailed,
        monthly: defaultView.monthly,
        viewLabel: defaultView.name,
        viewId: defaultView._id,
        filters: defaultView.filters,
        startDate: defaultView.startDate,
        endDate: defaultView.endDate,
        selectedLabel: defaultView.dateRange,
      });
    }

    this.setState({
      items: {
        ...this.state.items, //copy all the properties
        assigned: this.mapBreakdownColumns(defaultView.breakdowns),
      },
    });

    if (this.props.TURNOVER_GROUPINGS.length) {
      this.cloneGroup = JSON.parse(
        JSON.stringify(this.props.TURNOVER_GROUPINGS)
      );
    } else {
      this.cloneGroup = [];
    }

    this.getRangeFromLabel();
    this.startUpRange = this.state.selectedRange;
    ///await this.initView();

  }

  getFilterValue = async () => {
    let { company, companyId } = this.props.UserReducer;
    let { filterValues } = await this.getRecords(companyId, company, this.state.startDate, this.state.endDate);
    this.setState({ getFilter: filterValues });
  };
  initView = async () => {
    let { company, companyId } = this.props.UserReducer;
    //get report data
    let { records, columns, filterValues, advanceGroupingValues } =
      await this.getRecords(
        companyId,
        company,
        this.state.startDate,
        this.state.endDate
      );
    //prepare records
    this.cloneRecords = JSON.parse(JSON.stringify(records));
    this.filterAndAddGroupings(records);
    //set available columns
    this.mapAvailableColumns(
      columns,
      this.props.TURNOVER_GROUPINGS,
      this.state.breakdownColumns
    );
    //group report
    this.groupReport(
      this.state.breakdownColumns,
      this.state.preparedRecords,
      this.state.monthly
    );
    this.setState({
      records,
      filterValues,
      loading: false,
      advanceGroupingValues,
    });
    this.state.filters.forEach((val) => {
      this.selectFilterColumn(val.columnName);
    });
    this.setFiltersColumn();
    this.setState({
      selectedFilterColumn: "",
    });
  };

  //it is used to get updated value
  async componentDidUpdate(prevProps, prevState) {
    if (prevState.isRender !== this.state.isRender) {
      this.componentDidMount();
    }
  }

  getRangeFromLabel = (label) => {
    let { selectedLabel, ranges } = this.state;
    let rangeLabel = label || selectedLabel;
    let range = ranges.find((r) => r.label === rangeLabel);
    this.handleSelect(range);
  };

  //use to get selected breakdown columns
  mapBreakdownColumns = (columns) => {
    return columns.map((col) => {
      let { columnName, customGrouping } = col;
      return {
        ...col,
        value: col.value || customGrouping?.groupName || columnName,
        label:
          customGrouping !== undefined
            ? `${startCase(customGrouping.groupName)} / ${startCase(
              columnName
            )}`
            : startCase(columnName || col),
      };
    });
  };

  mapAvailableColumns = (columns, groupings, bdCols) => {
    let availCols = [
      ...columns.map((col) => {
        return {
          value: col.value || col,
          label: col.label || startCase(col),
        };
      }),
      ...groupings.map((grp) => {
        let { groupName, columnName } = grp;
        return {
          ...grp,
          value: groupName,
          label: `${startCase(groupName)} / ${startCase(columnName)}`,
          columnName,
        };
      }),
    ].filter((clm) => {
      return !bdCols.find((bd) => bd.value === clm.value);
    });
    let chkUniqueCol = availCols.reduce((unique, o) => {
      if (!unique.some((obj) => obj.label === o.label)) {
        unique.push(o);
      }
      return unique;
    }, []);

    this.setState({
      items: {
        ...this.state.items, //copy all the properties
        available: sortBy(chkUniqueCol, "label"),
      },
    });

    this.setState({ availableColumns: sortBy(chkUniqueCol, "label") });
  };

  // get records from api
  getRecords = async (companyId, company, startDate, endDate) => {
    if (!startDate || !endDate) return;
    let _startDate = format(new Date(startDate), "MM-dd-yyyy"),
      _endDate = format(new Date(endDate), "MM-dd-yyyy");
    await this.props.turnoverRate({
      companyId,
      company,
      startDate: _startDate,
      endDate: _endDate,
    });
    this.setFiltersColumn();
    return this.props.TURNOVER_RATE || {};
  };
  // it is used to get views
  getViews = async (companyId) => {
    await this.props.turnoverViews(companyId);
    return this.props.TURNOVER_VIEWS || [];
  };

  filterAndAddGroupings = (records) => {
    let { filters } = this.state;
    let customGroupings = this.props.TURNOVER_GROUPINGS;
    let filteredRecords = records.filter((rec) => {
      let filtered = [];
      filters.forEach((fltr) => {
        let { columnName, values } = fltr;
        filtered.push(values.includes(rec[columnName]));
      });

      return filtered.every((e) => e === true);
    });
    let preparedRecords = filteredRecords.map((rec) => {
      customGroupings.forEach((cg) => {
        let { groups, columnName, groupName } = cg;
        let group = groups.find((grp) => grp.values.includes(rec[columnName]));
        if (group) rec[groupName] = group.name;
      });
      return rec;
    });

    let useRecords = preparedRecords.filter((rec) => {
      let filtered = [];
      this.state.breakdownColumns?.forEach((fltr) => {
        if (fltr.company || fltr.customGrouping) {
          let { value } = fltr;
          filtered.push(value in rec);
        }
      });
      return filtered.every((e) => e === true);
    });
    this.setState({ preparedRecords: useRecords })
  };

  groupReport = (breakDownBy, report, isMonthly) => {
    ["companyShortName", ...breakDownBy].forEach((bd) => {
      report = this.groupRecords(report, bd);
    });

    //this second call of the grouping function is for monthly view
    report = this.groupRecords(report, "", true);
    let values = this.calculateRate(report, isMonthly);
    delete values.sum;
    delete values.monthlyView;
    values = this.unpack(values);
    values = (values[this.state.company] || {});
    values.label = this.state.company;
    values = this.convertToTree(values);

    this.setState({ groupedReport: values });

  };

  //used to group each record set in report recursively
  groupRecords = (dataset, breakdownVal, byMonth) => {
    breakdownVal = breakdownVal?.value || breakdownVal;
    if (Array.isArray(dataset)) {
      let sum = [...dataset];
      let grouped = {};
      let monthlyView = {};
      if (byMonth) {
        monthlyView = this.groupByDate([...dataset]);
      } else {
        grouped = groupBy(dataset, breakdownVal);
      }
      dataset = { ...grouped, sum, monthlyView };
    } else {
      for (let key in dataset) {
        if (!byMonth) {
          if (key !== "sum" && key !== 'monthlyView') {
            dataset[key] = this.groupRecords(dataset[key], breakdownVal, byMonth);
          };
        } else {
          if (key !== 'monthlyView') {
            dataset[key] = this.groupRecords(dataset[key], breakdownVal, byMonth);
          };
        }
      };
    };
    return dataset;
  };

  groupByDate = (dataset) => {
    let { startDate, endDate } = this.state;
    let everyMonth = startAndEndOfMonthsInRange(startDate, endDate, 2);
    let data = {};
    let monthNames = [];
    everyMonth.forEach((month) => {
      let [sDate, eDate] = month;
      let monthName = format(sDate, "MMM-yyyy");
      monthNames.push(monthName);
      data[monthName] = dataset.filter((rec) => this.filterActiveByDate(rec, sDate, eDate));
    });
    this.setState({ monthNames: uniq(monthNames) });
    return data;
  };

  calculateRate = (dataset, isMonthly, key, parent) => {
    if (Array.isArray(dataset)) {
      let dateNum = Date.parse(key);
      if (!isMonthly || (isMonthly && !isNaN(dateNum))) {
        dataset = this.getRate(dataset, isMonthly, key, parent);
      };
    } else if (typeof dataset === "object") {
      for (let prop in dataset) {
        dataset[prop] = this.calculateRate(dataset[prop], isMonthly, prop, dataset);
      }
    }
    return dataset;
  };

  unpack = report => {
    for (let prop in report) {
      if (prop === 'sum') {
        if (report[prop].hasOwnProperty('sum')) {
          let { monthlyView, sum } = report.sum;
          report = { ...report, monthlyView, ...sum };
          delete report.sum;
        } else {
          let { sum } = report;
          report = { ...report, ...sum };
          delete report.sum;
        }
      } else {
        if (typeof report[prop] === 'object') {
          if (prop !== 'monthlyView') report[prop].label = prop;
          report[prop] = this.unpack(report[prop]);
        };
      };
    };
    return report;
  };

  convertToTree = data => {
    if (Array.isArray(data)) {
      data = data.map(d => this.convertToTree(d));
    } else {
      let children = [];
      for (let prop in data) {
        if (typeof data[prop] === 'object' && prop !== 'monthlyView') {
          children.push(data[prop]);
        };
      };
      data.children = children;
      this.convertToTree(data.children);
      return data;
    }
  };

  filterActiveByDate = (record, startDate, endDate) => {
    let { dateHired, dateTerminated } = record;
    return (
      isSameOrBefore(new Date(dateHired), endDate) &&
      (!dateTerminated || isSameOrAfter(new Date(dateTerminated), startDate))
    );
  };

  getRate = (dataSet, isMonthly, propVal, parent) => {
    let { startDate, endDate } = this.state;
    if (propVal) {
      let parsed = Date.parse(propVal);
      if (!isNaN(parsed)) {
        startDate = new Date(parsed);
        endDate = endOfMonth(new Date(parsed));
      }
    }
    let everyDay = enumerateDatesInRange(startDate, endDate);
    let dailyHeadCount = everyDay.reduce((total, day) => {
      let dayCount = dataSet.filter((emp) => {
        return (
          isSameOrBefore(new Date(emp.dateHired), day) &&
          (!emp.dateTerminated ||
            isSameOrAfter(new Date(emp.dateTerminated), day))
        );
      }).length;
      total += dayCount;
      return total;
    }, 0);
    let avgDailyHeadCount = dailyHeadCount / everyDay.length;

    let _terminated = dataSet.filter((emp) => {
      let { dateTerminated } = emp;
      let terminatedInDateRange = dateTerminated
        && isSameOrAfter(new Date(dateTerminated), startDate)
        && isSameOrBefore(new Date(dateTerminated), endDate);
      return terminatedInDateRange;
    });
    let allTerminated = _terminated.length;
    let rate = (allTerminated / avgDailyHeadCount) * 100;
    let value = {
      allTerminated,
      avgDailyHeadCount: Math.round(avgDailyHeadCount),
      rate: (isNaN(rate) || rate === undefined) ? 0 : rate.toFixed(2),
    };
    if (propVal !== "sum") value.label = propVal;
    return value;
  };

  // get records according to date range
  handleDateRange = async (startDate, endDate) => {
    this.setState({ startDate, endDate, loading: true }, () => {
      this.initView();
    });
  };

  // it is used to select date range
  handleSelect = async (select) => {
    if (!select) return;
    this.setState({ selectedRange: select, selectedLabel: select.label });
    if (select.group !== "Custom") {
      await this.handleDateRange(select.from, select.to);
    }
  };

  // it is used to delete single value from breakdown column
  deleteBreakdownColumn = (draggedIndex, value) => {
    let { breakdownColumns, availableColumns, filters } = this.state;
    let availableColumn = breakdownColumns.splice(draggedIndex, 1).shift();

    availableColumns = sortBy([...availableColumns, availableColumn], "label");
    this.setState({
      breakdownColumns,
      availableColumns,
      filters,
      items: { assigned: breakdownColumns, available: availableColumns },
    });

    this.setFiltersColumn();
    this.selectUnselectAll(value, "deleteBreakdown");
  };

  reArrangeFilter = (filterValues, filterColumns, breakdownColumns) => {
    // changing the indexing in according to the breakdown
    let advanceGroupName = this.props.TURNOVER_GROUPINGS?.map((val) => val.groupName);
    let bdData = breakdownColumns.map((e) => e.value);

    let valueExistOrNot = advanceGroupName?.some((r) => bdData.includes(r));

    if (valueExistOrNot === false) {
      let newFilter = Object.keys(filterValues).map((e) => e);
      let newBrk = breakdownColumns.map((e) => {
        return e.value;
      });

      let data = newFilter.filter((val) => !newBrk.includes(val));

      let reCombineFilter = [...newBrk, ...data];

      let indexObject = reduce(
        filterColumns,
        function (result, currentObject) {
          result[currentObject.value] = currentObject;
          return result;
        },
        {}
      );
      let newMap = map(reCombineFilter, function (currentValue) {
        return indexObject[currentValue];
      });

      this.setState({ availFilterColumns: newMap });
    } else {
      let newFilter = Object.keys(filterValues).map((e) => e);
      let newBrk = breakdownColumns.map((e) => {
        return e.value;
      });

      let data = newFilter.filter((val) => !newBrk.includes(val));

      let reCombineFilter = [...newBrk, ...data];

      let indexObject = reduce(
        filterColumns,
        function (result, currentObject) {
          result[currentObject.value] = currentObject;
          return result;
        },
        {}
      );
      let newMap = map(reCombineFilter, function (currentValue) {
        return indexObject[currentValue];
      });

      let removeUndefined = newMap.filter((x) => x !== undefined);

      this.setState({
        availFilterColumns: removeUndefined,
      });
    }
  };

  setFiltersColumn = () => {
    let { filterValues, breakdownColumns } = this.state;
    let filterColumns = Object.keys(filterValues)?.map((val) => {
      let label = startCase(val);
      let usedInBreakdowns = breakdownColumns.find((bd) => bd.value === val);

      return { value: val, label, pinned: !!usedInBreakdowns };
    });

    this.reArrangeFilter(filterValues, filterColumns, breakdownColumns);
  };

  selectFilterColumn = (filterCol, setFiltersValue, value) => {
    let filterColValues = this.state.filterValues;
    let values = [];

    let filterUsed;
    if (setFiltersValue === "true") {
      filterColValues = value;
      filterUsed = this.state.savedFilters.find(
        (ft) => ft.columnName === filterCol
      );
    } else {
      filterUsed = this.state.filters.find((ft) => ft.columnName === filterCol);
    }
    if (filterUsed) {
      values = filterUsed.values;
    }
    filterColValues[filterCol] = filterColValues[filterCol] && filterColValues[filterCol].map((fv) => ({
      value: fv?.value || fv,
      checked: values.includes(fv?.value || fv),
    }));
    let allSelected = filterColValues[filterCol] && filterColValues[filterCol].every((el) => !!el.checked);
    this.setState({
      filterValues: filterColValues,
      selectedFilterColumn: filterCol,
      allSelected,
    });
  };

  selectFilterValue = (e, i) => {
    let { filterValues, selectedFilterColumn, breakdownColumns } = this.state;
    let usedBd = breakdownColumns.find(
      (bd) => bd.value === selectedFilterColumn
    );
    if (usedBd) {
      filterValues[selectedFilterColumn][i].checked = e.target.checked;
      let allSelected = filterValues[selectedFilterColumn].every(
        (el) => !!el.checked
      );
      this.setState({ filterValues, allSelected });
    }
  };

  selectUnselectAll = (value, isDeleteBreakdown) => {
    let { selectedFilterColumn, filterValues, breakdownColumns } = this.state;
    let selectedColumn;
    if (typeof value === "string") {
      selectedColumn = value;
    } else {
      selectedColumn = selectedFilterColumn;
    }

    let usedBd = breakdownColumns.find((bd) => bd.value === selectedColumn);

    if (usedBd) {
      if (filterValues[selectedColumn] !== undefined) {
        let allSelected = filterValues[selectedColumn].every(
          (el) => !!el.checked
        );
        filterValues[selectedColumn] = filterValues[selectedColumn].map(
          (el) => ({
            value: el?.value || el,
            checked: !el?.checked || !allSelected,
          })
        );
        this.setState({ filterValues, allSelected: !allSelected });
        let filters = [];
        for (let columnName in filterValues) {
          let filterUsed = filterValues[columnName].filter((fv) => fv.checked);
          if (filterUsed.length)
            filters.push({
              columnName,
              values: filterUsed.map((fu) => fu.value),
            });
        }
        this.setState({ filters });
      }
    }
    if (isDeleteBreakdown) {
      if (filterValues[value] !== undefined) {
        let allSelected = filterValues[value].every((el) => !!el.checked);
        filterValues[value] = filterValues[value].map((el) => ({
          value: el?.value || el,
          checked: false,
        }));
        this.setState({ filterValues, allSelected: !allSelected });
        let filters = [];
        for (let columnName in filterValues) {
          let filterUsed = filterValues[columnName].filter((fv) => fv.checked);
          if (filterUsed.length)
            filters.push({
              columnName,
              values: filterUsed.map((fu) => fu.value),
            });
        }
        this.setState({ filters });
      }
    }
  };

  applySettings = () => {
    let { filterValues, records } = this.state;
    let filters = [];
    for (let columnName in filterValues) {
      let filterUsed = filterValues[columnName].filter((fv) => fv.checked);
      if (filterUsed.length)
        filters.push({
          columnName,
          values: filterUsed.map((fu) => fu.value),
        });
    }

    this.setState({ isOpenSettings: false, filters });
    this.filterAndAddGroupings(records);
    this.groupReport(
      this.state.breakdownColumns,
      this.state.preparedRecords,
      this.state.monthly
    );
    this.setState({
      isRefresh: true,
    });
  };

  refreshGrid = () => {
    let { availableColumns, breakdownColumns } = this.state;
    this.mapAvailableColumns(
      availableColumns,
      this.props.TURNOVER_GROUPINGS,
      breakdownColumns
    );
    if (this.props.TURNOVER_GROUPINGS.length) {
      this.cloneGroup = JSON.parse(
        JSON.stringify(this.props.TURNOVER_GROUPINGS)
      );
    } else {
      this.cloneGroup = [];
    }
  };

  //it is used to save the turnover view in api
  saveTurnoverView = async (fState = {}) => {
    let {
      monthly,
      detailed,
      filters,
      breakdownColumns,
      selectedLabel,
      startDate,
      endDate,
    } = this.state;
    let { companyId } = this.props.UserReducer;
    let breakdowns = breakdownColumns.map((bd) => {
      let columnName;
      let customGrouping;
      let brkDn;
      if (bd.groups !== undefined || bd.customGrouping !== undefined) {
        columnName =
          bd.customGrouping === undefined
            ? bd.columnName
            : bd.customGrouping.columnName;
        customGrouping =
          bd.customGrouping === undefined ? bd._id : bd.customGrouping._id;
        brkDn = { customGrouping, columnName };
      } else {
        columnName = bd.value;
        brkDn = { columnName };
      }

      return brkDn;
    });
    let dateRange = selectedLabel;
    if (dateRange !== "Custom") {
      startDate = null;
      endDate = null;
    } else {
      startDate = Number(startDate);
      endDate = Number(endDate);
    }
    let payload = {
      company: companyId,
      breakdowns,
      monthly,
      detailed,
      filters,
      dateRange,
      startDate,
      endDate,
      ...fState,
    };
    await this.props.saveTurnoverView(payload);
    let savedViews = await this.getViews(companyId);
    let newView = savedViews.find((v) => v.name === payload.name);
    this.setState({
      isShow: false,
      savedViews,
      viewLabel: newView === undefined ? this.state.viewLabel : newView.name,
      viewId: newView === undefined ? this.state.viewId : newView?._id,
    });
  };

  searchInput = async (e) => {
    if (e.target.value !== 0) {
      // add the redux  action for search api
    }
  };

  toggleMonthlyView = (e) => {
    this.setState({ monthly: e.target.checked });
    this.groupReport(
      this.state.breakdownColumns,
      this.state.records,
      e.target.checked
    );
  };

  openSaveViewModal = () => {
    this.setState({ isShow: true, editViewData: {} });
  };

  closeSaveViewModal = () => {
    this.setState({
      isOpenSettings: false,
      isShow: false,
      isEdit: false,
      editRow: {},
    });
  };

  toggleSettings = (settingFalse) => {
    let isOpenSettings = !this.state.isOpenSettings;
    let setFiltersValue = "true";

    let {
      availableColumns,
      savedAvailableColumns,
      breakdownColumns,
      savedBreakdowns,
    } = this.state;

    if (isOpenSettings) {
      this.setState({
        savedAvailableColumns: availableColumns.map((e) => e),
        savedBreakdowns: breakdownColumns.map((e) => e),
        savedFilters: this.state.filters,
      });

      this.setFiltersColumn();
    } else {
      let value = this.state.getFilter;
      if (this.state.savedFilters.length) {
        this.state.savedFilters.forEach((val) => {
          this.selectFilterColumn(val.columnName, setFiltersValue, value);
        });
      } else {
        this.setState({ filterValues: this.state.getFilter });
      }

      this.setState({
        availableColumns: savedAvailableColumns,
        breakdownColumns: savedBreakdowns,
        savedAvailableColumns: [],
        savedBreakdowns: [],
        filters: this.state.savedFilters,
        items: { assigned: savedBreakdowns, available: savedAvailableColumns },
      });
      this.getFilterValue();
    }

    if (settingFalse === true && isOpenSettings) {
      this.setState({ isOpenSettings: false });
    } else {
      this.setFiltersColumn();
      this.setState({ isOpenSettings });
    }
  };

  showHideView = () => {
    let { isShowHideView } = this.state;
    this.setState({ isShowHideView: !isShowHideView });
  };

  openGroupingModel = () => {
    let isShowGroupingModal = !this.state.isShowGroupingModal;
    this.setState({ isShowGroupingModal });
  };

  onCloseGroupingModal = () => {
    this.setState({ isShowGroupingModal: false });
  };

  // onChangeView is used to change view in saved views drop down
  onChangeView = async (view) => {
    this.setState({
      loading: true,
      breakdownColumns: this.mapBreakdownColumns(view.breakdowns),
      detailed: view.detailed,
      monthly: view.monthly,
      viewLabel: view.name,
      viewId: view._id,
      filters: view.filters,
      startDate: view.startDate,
      endDate: view.endDate,
      selectedLabel: view.dateRange,
      isShowHideView: false,
    });
    this.getRangeFromLabel(view.dateRange);
    await this.initView();
  };

  // editing the view
  onEditTurnoverView = (item) => {
    let { _id, name, description, isDefault } = item;
    let { isShowHideView } = this.state;
    this.setState({
      isShow: true,
      isEdit: true,
      editViewData: { _id, name, description, isDefault },
      isShowHideView: !isShowHideView,
    });
  };
  // deleting the view
  onDeleteTurnoverView = async () => {
    let viewId = this.state.deleteViewId;
    await this.props.deleteSavedView(viewId);
    let { isShowHideView } = this.state;
    this.setState({
      isShowHideView: !isShowHideView,
      isRender: !this.state.isRender,
      showConfirmationBox: false,
    });
  };
  toggleConfirmationPopup = () => {
    this.setState({ showConfirmationBox: false, deleteViewId: "" });
  };
  confirmationPopupOpen = (_id) => {
    this.setState({ showConfirmationBox: true, deleteViewId: _id });
  };
  confirmDeleteGrouping = async (groupId) => {
    await this.props.confirmDeleteGrouping(groupId);
    if (this.props.GROUPING_ALLOW_DELETE) {
      await this.props.deleteCustomGrouping(groupId);
      let { companyId } = this.props.UserReducer;
      await this.props.turnoverGroupings(companyId);
      this.setState({ isRender: !this.state.isRender });
    } else {
      ToastMessage(
        "This Grouping Is Being Used In a Saved View And Cannot Be Deleted",
        "error"
      );
    }
    return this.props.GROUPING_ALLOW_DELETE;
  };
  onMouseOverBreakDropDownList = () => {
    let breakDownDrop = !this.state.breakDownDrop;
    this.setState({ breakDownDrop });
  };

  onMouseLeaveBreakDropDownList = () => {
    this.setState({ breakDownDrop: false });
  };
  refreshAgGridAdvancedSaved = async (val) => {
    if (val === !undefined && "true") {
      this.setState({ records: this.cloneRecords });
      this.applySettings();
      this.createClone();
    }
  };
  createClone = async () => {
    let { company, companyId } = this.props.UserReducer;
    let { records } = await this.getRecords(
      companyId,
      company,
      this.state.startDate,
      this.state.endDate
    );
    this.cloneRecords = JSON.parse(JSON.stringify(records));
  };

  refreshAgGrid = (val) => {
    if (val === !undefined && "true") {
      this.setState({ isRefresh: !this.state.isRefresh });
    }
  };

  onDragEnd = (result) => {
    if (!result.destination) {
      return;
    };
    const listCopy = { ...this.state.items };
    const sourceList = listCopy[result.source.droppableId];
    const [removedElement, newSourceList] = this.removeFromList(
      sourceList,
      result.source.index
    );
    listCopy[result.source.droppableId] = newSourceList;
    let isMatched = [removedElement.value].some((ai) => [removedElement.columnName].includes(ai));
    let isFounded;
    let newDrop = [removedElement.columnName] || [removedElement.value];
    let brkBd = newDrop[0] === undefined ? [removedElement.value] : [removedElement.columnName];
    if (isMatched) {
      let colExistTwo = listCopy.assigned.map((e) => e.columnName);
      isFounded = colExistTwo.some((ai) => brkBd.includes(ai));
    } else {
      if ([removedElement.columnName][0] === undefined) {
        let colExistTwo = listCopy.assigned.map((e) => e.columnName);
        isFounded = colExistTwo.some((ai) => brkBd.includes(ai));
      } else {
        let colExistOrNot = listCopy.assigned.map((e) => e.value);
        isFounded = colExistOrNot.some((ai) => brkBd.includes(ai));
      };
    };
    if (isFounded) {
      return;
    };

    const destinationList = listCopy[result.destination.droppableId];
    listCopy[result.destination.droppableId] = this.addToList(
      destinationList,
      result.destination.index,
      removedElement
    );
    this.setState({
      items: listCopy,
      breakdownColumns: listCopy.assigned,
      availableColumns: listCopy.available
    });
    this.setFiltersColumn();
    if (result.destination.droppableId === "available") {
      this.selectUnselectAll(result.draggableId, "deleteBreakdown");
    } else {
      if (result.destination.droppableId === "assigned") {
        this.selectUnselectAll(result.draggableId);
      };
    };
  };

  removeFromList = (list, index) => {
    const result = Array.from(list);
    const [removed] = result.splice(index, 1);
    return [removed, result];
  };

  addToList = (list, index, element) => {
    const result = Array.from(list);
    result.splice(index, 0, element);
    return result;
  };

  showSearchInput = (clickCheck) => {
    if (clickCheck === "avClick") {
      let showHideAvail = !this.state.showHideAvail;
      this.setState({ showHideAvail });
      this.setState({ searchAvailableColumn: "" });
    };
    if (clickCheck === "brClick") {
      let showHideBreak = !this.state.showHideBreak;
      this.setState({ showHideBreak });
      this.setState({ searchBreakdown: "" });
    };
    if (clickCheck === "filterClick") {
      let showHideFilterBy = !this.state.showHideFilterBy;
      this.setState({ showHideFilterBy });
      this.setState({ searchFilter: "" });
    };
    if (clickCheck === "avFilterClick") {
      let showHideAvailFilter = !this.state.showHideAvailFilter;
      this.setState({ showHideAvailFilter });
      this.setState({ searchAvailableFields: "" });
    };
  };

  render() {
    let {
      advanceGroupingValues,
      allSelected,
      availFilterColumns,
      breakDownDrop,
      breakdownColumns,
      company,
      detailed,
      endDate,
      filterValues,
      groupedReport,
      isOpenSettings,
      isRefresh,
      isShowGroupingModal,
      isShowHideView,
      loading,
      monthNames,
      monthly,
      savedViews,
      searchAvailableColumn,
      searchAvailableFields,
      searchBreakdown,
      searchFilter,
      selectedFilterColumn,
      startDate,
      viewId,
      viewLabel,
    } = this.state;

    return (
      <>
        <div className="table-header d-flex align-items-center justify-content-between turnover-rate-header">
          <h4 className="heading_h4">Turnover Rate</h4>
          <div
            className="notification ms-1"
            data-class="turnover_tool_tip "
            data-tip="Turnover rate refers to the 
                    percentage of employees leaving a 
                    company within a
                     certain period of time"
          >
            <img src={informationTooltip} alt="Information Tooltip" />
          </div>
          <Tooltip place="right" type="dark" effect="float" />
          <div className="mla d-flex align-items-center justify-content-between"></div>
        </div>
        <div className="shadow_white_box full-box mt-0 turnover-rate-page">
          <div className="filter-list turnover-rate">
            <div className="filter-list-top">
              <div className="filter-group-left">
                <div className="filter-field">
                  <input
                    type="text"
                    placeholder="Search"
                    onChange={(e) => this.searchInput(e)} />
                </div>
                <div className="filter-field">
                  <Switch
                    onChange={this.toggleMonthlyView}
                    value={monthly}
                    disabled={loading}></Switch>
                  <label className="ms-2 font-14">Show monthly view</label>
                </div>
                {monthly && (
                  <div className="filter-field">
                    <input
                      type="checkbox"
                      checked={detailed}
                      onChange={(e) => this.setState({ detailed: e.target.checked })} />
                    <label className="ms-2 font-14">Show additional details</label>
                  </div>
                )}
              </div>
              <div className="filter-group-right">
                <OutsideClickHandler
                  onOutsideClick={() => {
                    this.setState({ isShowHideView: false });
                  }}
                >
                  <div className="view-container">
                    <label>Saved views</label>


                    <div className="filter-field view-dropDown-outer" >
                      <div
                        className={`select-dropDown ${isShowHideView ? "active" : ""}`}
                        onClick={this.showHideView}
                      >
                        {viewLabel}
                      </div>
                      {isShowHideView && (
                        <div className="view-dropDown-list">
                          {savedViews.map((item, idx) => (
                            <div
                              className={`drop-down-field ${item.isDefault ? "isDefault" : ""}`}
                              key={idx}
                            >
                              <span
                                className="view-name"
                                onClick={async () => await this.onChangeView(item)}
                              >
                                {item.name || "--"}
                                {item.isDefault && (
                                  <span className="isDefault-active">
                                    Default
                                  </span>
                                )}
                              </span>
                              <div className="view-actions">
                                <span
                                  className="edit-view"
                                  onClick={() => this.onEditTurnoverView(item)}
                                ></span>
                                <span
                                  className="delete-view"
                                  onClick={() => this.confirmationPopupOpen(item._id)}
                                ></span>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </OutsideClickHandler>
                {this.state.showConfirmationBox && (
                  <Portal
                    zIndex="101"
                    height="164px"
                    width="424px"
                    close={this.toggleConfirmationPopup}
                    title="Confirmation"
                  >
                    <ConfirmationPopUp
                      message="Are you sure you want to delete this View?"
                      id={this.state.id}
                      close={this.toggleConfirmationPopup}
                      confirmation={this.onDeleteTurnoverView}
                    ></ConfirmationPopUp>
                  </Portal>
                )}
              </div>
            </div>
          </div>

          <div className="filter-list turnover-rate">
            <div className="filter-list-bottom">
              <div className="filter-group-left">
                <ReportDateRange
                  startDate={startDate}
                  endDate={endDate}
                  startUpRange={this.startUpRange}
                  handleDateRange={this.handleDateRange}
                  handleSelect={this.handleSelect}
                  style={{
                    container: {
                      padding: '5px',
                    }
                  }}
                ></ReportDateRange>
              </div>

              <OutsideClickHandler
                onOutsideClick={() => {
                  let settingFalse = true;
                  this.toggleSettings(settingFalse);
                }}
              >
                <div className="setting_popup" id="setting_id">
                  <button
                    className={`${isOpenSettings
                      ? "btn setting-btn ms-3 py-1 px-3 active-settings"
                      : "btn setting-btn ms-3 py-1 px-3"
                      }`}
                    onClick={this.toggleSettings}
                    disabled={loading}
                  >
                    {loading ? "Loading.." : "Settings"}

                    {!loading && (
                      <span
                        onMouseOver={this.onMouseOverBreakDropDownList}
                        onMouseLeave={this.onMouseLeaveBreakDropDownList}
                        className="setting_length_btn"
                      >
                        {breakdownColumns.length}
                      </span>
                    )}
                  </button>
                  <div className="breakdown-data">
                    {breakDownDrop && (
                      <div className="breakdown-dropdown">
                        <ul className="d-flex flex-column ps-0 m-0">
                          {breakdownColumns &&
                            breakdownColumns.map((el, i) => {
                              return (
                                <li className="breakdown-list" key={i}>
                                  <label htmlFor="test3">{el?.label}</label>
                                </li>
                              );
                            })}
                        </ul>
                      </div>
                    )}
                  </div>

                  {isOpenSettings && (
                    <>
                      {/* <div className="group-overlay-pop"></div> */}
                      <div className="columns-setting-box">
                        <Tabs
                          defaultActiveKey="grouping_tab"
                          id="uncontrolled-tab-example"
                          className="mb-3"
                        >
                          <Tab eventKey="grouping_tab" title="Grouping">
                            <div className="column-box-outer d-flex align-content-center">
                              <DragDropContext onDragEnd={this.onDragEnd}>
                                {/* available columns box starts here */}
                                <div
                                  className="column-box"
                                >
                                  <OutsideClickHandler
                                    onOutsideClick={() => {
                                      this.setState({
                                        showHideAvail: false,
                                        searchAvailableColumn: "",
                                      });
                                    }}
                                  >
                                    <h3 className="column-head d-flex align-items-center position-relative">
                                      Available Columns
                                      <button
                                        className="btnSearch ms-auto border-0"
                                        type="button"
                                        onClick={() => {
                                          let clickCheck = "avClick";
                                          this.showSearchInput(clickCheck);
                                        }}
                                      >
                                        <img src={searchIcon} alt="" />
                                      </button>
                                      {this.state.showHideAvail && (
                                        <input
                                          autoFocus
                                          className="filterSearch"
                                          type="text"
                                          name="searchAvailableColumn"
                                          value={searchAvailableColumn}
                                          onChange={(e) =>
                                            this.setState({
                                              searchAvailableColumn:
                                                e.target.value.replace(
                                                  /[^a-z0-9]/gi,
                                                  ""
                                                ),
                                            })
                                          }
                                        />
                                      )}
                                    </h3>
                                  </OutsideClickHandler>
                                  <div className="columns-list">
                                    <ul className="in-drag">
                                      <Droppable droppableId="available">
                                        {(provided, snapshot) => (
                                          <div
                                            ref={provided.innerRef}
                                            className="h-screen"
                                          >
                                            {this.state.items.available

                                              .filter((el) => {
                                                return el.label.match(
                                                  new RegExp(
                                                    searchAvailableColumn,
                                                    "i"
                                                  )
                                                );
                                              })
                                              .map((item, index) => (
                                                <li className="position-relative" key={index}>
                                                  <Draggable
                                                    key={item.value}
                                                    draggableId={item.value}
                                                    index={index}
                                                  >
                                                    {(provided, snapshot) => (
                                                      <div>
                                                        <div
                                                          ref={
                                                            provided.innerRef
                                                          }
                                                          {...provided.draggableProps}
                                                          {...provided.dragHandleProps}
                                                          className={snapshot.isDragging ? 'dragging-list' : ''}
                                                        >
                                                          <span className="number-count">
                                                            {index + 1}
                                                          </span>
                                                          <div className="inner-column-text">
                                                            {item.label}
                                                          </div>
                                                        </div>
                                                      </div>
                                                    )}
                                                  </Draggable>
                                                </li>
                                              ))}

                                            {provided.placeholder}
                                          </div>
                                        )}
                                      </Droppable>
                                    </ul>
                                  </div>
                                </div>
                                {/* breakdown columns box starts here */}
                                <div className="column-compare-box"></div>
                                <div
                                  className="column-box"
                                >
                                  <OutsideClickHandler
                                    onOutsideClick={() => {
                                      this.setState({
                                        showHideBreak: false,
                                        searchBreakdown: "",
                                      });
                                    }}
                                  >
                                    <h3 className="column-head d-flex align-items-center position-relative">
                                      Breakdown By
                                      <button
                                        className="btnSearch ms-auto border-0"
                                        type="button"
                                        onClick={() => {
                                          let clickCheck = "brClick";
                                          this.showSearchInput(clickCheck);
                                        }}
                                      >
                                        <img src={searchIcon} alt="" />
                                      </button>
                                      {this.state.showHideBreak && (
                                        <input
                                          autoFocus
                                          className="filterSearch"
                                          type="text"
                                          name="searchBreakdown"
                                          value={searchBreakdown}
                                          onChange={(e) =>
                                            this.setState({
                                              searchBreakdown:
                                                e.target.value.replace(
                                                  /[^a-z0-9]/gi,
                                                  ""
                                                ),
                                            })
                                          }
                                        />
                                      )}
                                    </h3>
                                  </OutsideClickHandler>
                                  <div className="columns-list breakdown-box">
                                    <ul className="in-drag">
                                      <Droppable droppableId="assigned">
                                        {(provided, snapshot) => (
                                          <div
                                            ref={provided.innerRef}
                                            className="h-screen"
                                          >
                                            {this.state.items.assigned
                                              .filter((el) => {
                                                return el.label.match(
                                                  new RegExp(
                                                    searchBreakdown,
                                                    "i"
                                                  )
                                                );
                                              })
                                              .map((item, index) => (
                                                <li className="position-relative" key={index}>
                                                  <Draggable
                                                    draggableId={
                                                      item.label
                                                    }
                                                    index={index}
                                                    key={item.label}
                                                  >
                                                    {(provided, snapshot) => (
                                                      <div
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                      >
                                                        {/* <div className="inner-column-text">
                                                          {item.label}
                                                        </div> */}

                                                        <span className="number-count">
                                                          {index + 1}
                                                        </span>
                                                        <div className="inner-column-text d-flex align-content-center justify-content-between">
                                                          <div className="breakdown-label">
                                                            {item?.label}
                                                          </div>
                                                          <div className="filter-action">
                                                            <span
                                                              className="delete-action"
                                                              onClick={() =>
                                                                this.deleteBreakdownColumn(
                                                                  index,
                                                                  item?.value
                                                                )
                                                              }
                                                            ></span>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    )}
                                                  </Draggable>
                                                </li>
                                              ))}
                                            {provided.placeholder}
                                          </div>
                                        )}
                                      </Droppable>
                                    </ul>
                                  </div>
                                </div>
                              </DragDropContext>
                            </div>
                          </Tab>
                          <Tab eventKey="filter_tab" title="Filters">
                            <div className="column-box-outer d-flex align-content-center">
                              <div className="column-box">
                                <OutsideClickHandler
                                  onOutsideClick={() => {
                                    this.setState({
                                      showHideFilterBy: false,
                                      searchFilter: "",
                                    });
                                  }}
                                >
                                  <h3 className="column-head d-flex align-items-center position-relative">
                                    Filter by
                                    <button
                                      className="btnSearch ms-auto border-0"
                                      type="button"
                                      onClick={() => {
                                        let clickCheck = "filterClick";
                                        this.showSearchInput(clickCheck);
                                      }}
                                    >
                                      <img src={searchIcon} alt="" />
                                    </button>
                                    {this.state.showHideFilterBy && (
                                      <input
                                        autoFocus
                                        className="filterSearch"
                                        type="text"
                                        name="searchFilter"
                                        value={searchFilter}
                                        onChange={(e) =>
                                          this.setState({
                                            searchFilter:
                                              e.target.value.replace(
                                                /[^a-z0-9]/gi,
                                                ""
                                              ),
                                          })
                                        }
                                      />
                                    )}
                                  </h3>
                                </OutsideClickHandler>

                                <div className="columns-list breakdown-box">
                                  <ul className="in-drag out-drag">
                                    {availFilterColumns
                                      .filter((el) => {
                                        return el.label.match(
                                          new RegExp(searchFilter, "i")
                                        );
                                      })
                                      .map((item, index) => {
                                        return (
                                          <li
                                            key={index}
                                            className="position-relative"
                                          >
                                            <span className="number-count">
                                              {index + 1}
                                            </span>
                                            <div
                                              className={`${selectedFilterColumn ===
                                                item.value
                                                ? "active"
                                                : ""
                                                } inner-column-text d-flex align-items-center justify-content-between`}
                                              role="button"
                                              onClick={() =>
                                                this.selectFilterColumn(
                                                  item.value
                                                )
                                              }
                                            >

                                              {item.label}
                                              {item.pinned && (
                                                <div className="pinnedIcon">
                                                  <img
                                                    src={pinnedFilterIcon}
                                                    alt="pinnedFilter"
                                                  />
                                                </div>
                                              )}
                                            </div>
                                          </li>
                                        );
                                      })}
                                  </ul>
                                </div>
                              </div>
                              <div className="column-compare-box no-bg"></div>
                              <div className="column-box">
                                <OutsideClickHandler
                                  onOutsideClick={() => {
                                    this.setState({
                                      showHideAvailFilter: false,
                                      searchAvailableFields: "",
                                    });
                                  }}
                                >
                                  <h3 className="column-head d-flex align-items-center position-relative">
                                    Available fields
                                    <button
                                      className="btnSearch ms-auto border-0"
                                      type="button"
                                      onClick={() => {
                                        let clickCheck = "avFilterClick";
                                        this.showSearchInput(clickCheck);
                                      }}
                                    >
                                      <img src={searchIcon} alt="" />
                                    </button>
                                    {this.state.showHideAvailFilter && (
                                      <input
                                        autoFocus
                                        className="filterSearch"
                                        type="text"
                                        name="searchAvailableFields"
                                        value={searchAvailableFields}
                                        onChange={(e) =>
                                          this.setState({
                                            searchAvailableFields:
                                              e.target.value.replace(
                                                /[^a-z0-9]/gi,
                                                ""
                                              ),
                                          })
                                        }
                                      />
                                    )}
                                  </h3>
                                </OutsideClickHandler>
                                {selectedFilterColumn && (
                                  <div className="select_all_filter">
                                    <label className="font-12">
                                      <input
                                        type="checkbox"
                                        name="selectAll"
                                        checked={allSelected}
                                        onChange={this.selectUnselectAll}
                                      />
                                      {allSelected
                                        ? "Unselect All"
                                        : "Select all"}
                                    </label>
                                  </div>
                                )}
                                <div className="columns-list breakdown-box">
                                  <div className="filters-option-list">
                                    {selectedFilterColumn &&
                                      filterValues[selectedFilterColumn]
                                        ?.filter((item) => {
                                          return item?.value?.match(
                                            new RegExp(
                                              searchAvailableFields,
                                              "i"
                                            )
                                          );
                                        })
                                        .map((item, idx) => {
                                          return (
                                            <div
                                              className="groups-value"
                                              key={idx}
                                            >
                                              <label className="font-12">
                                                <input
                                                  type="checkbox"
                                                  name={item.value}
                                                  checked={item.checked}
                                                  onChange={(e) =>
                                                    this.selectFilterValue(
                                                      e,
                                                      idx
                                                    )
                                                  }
                                                />
                                                {item.value}
                                              </label>
                                            </div>
                                          );
                                        })}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Tab>
                        </Tabs>

                        <div className="columns-setting-box-footer d-flex align-items-center justify-content-between">
                          <div className="d-flex align-content-center align-items-center">
                            <button
                              className="btn text-btn"
                              onClick={this.openGroupingModel}
                            >
                              Advanced grouping
                            </button>
                          </div>
                          <div className="d-flex align-items-center justify-content-between">
                            <button
                              className="btn close-btn"
                              onClick={this.toggleSettings}
                            >
                              Cancel
                            </button>
                            <button
                              className="btn save-btn"
                              onClick={() => this.applySettings()}
                            >
                              Go
                            </button>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </OutsideClickHandler>
            </div>
          </div>

          {!loading ? (
            <>
              <div className="custom-table mt-0">
                <div className="overflow">
                  <div className="custom-table-over">
                    <div className="custom-table-body">
                      <TurnoverView
                        report={[groupedReport]}
                        isRefresh={isRefresh}
                        startDate={new Date(startDate).toLocaleDateString()}
                        endDate={new Date(endDate).toLocaleDateString()}
                        monthly={monthly}
                        detailed={detailed}
                        monthNames={monthNames}
                        refreshAgGrid={this.refreshAgGrid}
                      ></TurnoverView>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className="loading-data d-flex align-items-center justify-content-center mt-0">
              <Loader></Loader>
            </div>
          )}
        </div>

        <div className="grid-footer d-flex align-items-center justify-content-end">
          <div className="footer-btn d-flex align-items-end justify-content-between">
            <button
              className="btn outline-btn ms-3"
              onClick={() => this.saveTurnoverView({ _id: viewId })}
              disabled={!viewId || this.state.btnDisable}
            >
              Update view
            </button>
            <button
              className="btn filled-btn  ms-3"
              onClick={this.openSaveViewModal}
              disabled={this.state.btnDisable}
            >
              Save as new view
            </button>
          </div>
        </div>
        {this.state.isShow && (
          <SaveViewModal
            show={this.state.isShow}
            isEdit={this.state.isEdit}
            onClose={this.closeSaveViewModal}
            view={this.state.editViewData}
            saveTurnoverView={this.saveTurnoverView}
          />)}
        {isShowGroupingModal && (
          <GroupingModal
            show={isShowGroupingModal}
            advanceGroupingValues={advanceGroupingValues}
            CustomGroupings={[...this.props.TURNOVER_GROUPINGS]}
            onClose={this.onCloseGroupingModal}
            confirmDeleteGroupingProp={this.confirmDeleteGrouping}
            company={company}
            refreshGrid={this.refreshGrid}
            refreshAgGrid={this.refreshAgGridAdvancedSaved}
            cloneGroup={this.cloneGroup}
          />
        )}
      </>
    );
  }
};

const mapStateToProps = ({ UserReducer, TurnoverReducer }) => {
  let {
    TURNOVER_RATE,
    TURNOVER_VIEWS,
    TURNOVER_GROUPINGS,
    GROUPING_ALLOW_DELETE,
  } = TurnoverReducer;
  return {
    UserReducer,
    TURNOVER_RATE,
    TURNOVER_VIEWS,
    TURNOVER_GROUPINGS,
    GROUPING_ALLOW_DELETE,
  };
};

export default connect(mapStateToProps, {
  turnoverRate,
  turnoverViews,
  saveTurnoverView,
  turnoverGroupings,
  deleteSavedView,
  confirmDeleteGrouping,
  deleteCustomGrouping,
})(TurnoverRateReport);
